import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitoshanishingnapurcab() {



    const cardData = {

keyword: "Mumbai to Shani Shingnapur Cab",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Mumbai to Shani Shingnapur Cab services for pilgrimage travel, family tours, and one-way or round-trip journeys. We provide a wide range of well-maintained vehicles including Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus with professional and experienced chauffeurs. With 24x7 availability, transparent pricing, doorstep pickup in Mumbai, and safe highway driving across Maharashtra routes, we ensure a smooth, comfortable, and hassle-free spiritual journey to Shani Shingnapur.",

topPlaces: [
    {
        title: "Shani Shingnapur Temple",
        description:
            "Shani Shingnapur is one of the most famous pilgrimage destinations in Maharashtra dedicated to Lord Shani. Devotees visit throughout the year seeking blessings, faith, and protection."
    },
    {
        title: "Shirdi Sai Baba Temple",
        description:
            "Shirdi is a major pilgrimage destination located near Shani Shingnapur, making it a popular combined spiritual tour for devotees traveling from Mumbai."
    },
    {
        title: "Nashik Trimbakeshwar",
        description:
            "Nashik is known for the Trimbakeshwar Jyotirlinga, vineyards, and religious significance, often included in extended pilgrimage routes from Mumbai."
    },
    {
        title: "Aurangabad Heritage Circuit",
        description:
            "Aurangabad is famous for Ajanta and Ellora Caves, offering a mix of spirituality and historical exploration for travelers on long routes from Mumbai."
    },
    {
        title: "Shani Dev Pratishthan Area",
        description:
            "The Shani Shingnapur region itself has temples and spiritual surroundings that offer a peaceful devotional experience for pilgrims."
    },
    {
        title: "Ahmednagar Stopover",
        description:
            "Ahmednagar is a key transit city on the way to Shani Shingnapur, providing rest stops, food options, and short breaks during travel."
    },
    {
        title: "Bhandardara",
        description:
            "Bhandardara is a scenic hill destination near the route, known for lakes, waterfalls, and natural beauty, often included in extended travel plans."
    },
    {
        title: "Shirdi Sai Nagar Path",
        description:
            "The road connecting Shirdi and Shani Shingnapur is a major pilgrimage corridor used by thousands of devotees traveling comfortably by cab."
    },
    {
        title: "Nevasa Temple Region",
        description:
            "Nevasa is a historical and spiritual area near Shani Shingnapur known for ancient temples and religious significance."
    },
    {
        title: "Devgad & Rural Maharashtra Route",
        description:
            "The route to Shani Shingnapur passes through peaceful rural Maharashtra landscapes, offering a calm and scenic travel experience."
    }
],



services: [
{
name: "Mumbai to Shani Shingnapur Cab",
description: "Mumbai Airport Cab offers Mumbai to Shani Shingnapur Cab service for safe, comfortable, and reliable pilgrimage travel to the famous Shani Shingnapur temple in Maharashtra. Whether you are travelling for darshan, family pilgrimage, religious tour, or weekend spiritual visit, we provide well-maintained vehicles including Sedan, SUV, Innova, Innova Crysta, Kia Carens, Tempo Traveller, and luxury options. Our professional chauffeurs are experienced in highway and rural routes, ensuring smooth driving, timely pickup, safety, and a stress-free journey. With doorstep pickup from Mumbai, flexible travel plans, transparent pricing, luggage assistance, and 24x7 support, we make your temple travel peaceful and convenient."
},
{
name: "Mumbai to Shani Shingnapur Taxi",
description: "Mumbai to Shani Shingnapur Taxi service by Mumbai Airport Cab provides dependable intercity pilgrimage transportation with clean, air-conditioned vehicles and experienced drivers. Ideal for families and groups visiting the Shani Shingnapur temple, we ensure safe highway travel, punctual pickup, and comfortable seating for a smooth journey from Mumbai."
},
{
name: "Mumbai to Shani Shingnapur Cab Fare",
description: "Mumbai to Shani Shingnapur Cab Fare with Mumbai Airport Cab is transparent, affordable, and based on vehicle type, distance, and travel requirements. We provide clear pricing with no hidden charges and flexible options for one-way and round-trip journeys, ensuring cost-effective pilgrimage travel with comfort and reliability."
},
{
name: "Mumbai to Shani Shingnapur Car Rental",
description: "Mumbai Airport Cab offers Mumbai to Shani Shingnapur Car Rental service with chauffeur-driven vehicles for long-distance temple travel. Our fleet includes comfortable sedans and spacious SUVs ideal for family and group pilgrimage. We ensure safe driving, luggage support, and flexible itineraries for a smooth travel experience."
},
{
name: "Mumbai to Shani Shingnapur One Way Cab",
description: "Mumbai to Shani Shingnapur One Way Cab service provides affordable travel for passengers who need a single journey without return charges. Mumbai Airport Cab ensures transparent pricing, comfortable vehicles, and professional chauffeurs for pilgrimage, family visits, and intercity travel."
},
{
name: "Mumbai to Shani Shingnapur Outstation Cab",
description: "Mumbai to Shani Shingnapur Outstation Cab service offers reliable long-distance travel with well-maintained vehicles and experienced drivers. Mumbai Airport Cab ensures safe highway driving, flexible schedules, and comfortable seating for stress-free temple journeys."
},
{
name: "Mumbai to Shani Shingnapur Pilgrimage Cab",
description: "Mumbai to Shani Shingnapur Pilgrimage Cab service is specially designed for devotees visiting the Shani Shingnapur temple. Mumbai Airport Cab provides experienced drivers, flexible travel schedules, and comfortable vehicles to ensure a peaceful and spiritual journey."
},
{
name: "Mumbai to Shani Shingnapur Temple Cab",
description: "Mumbai to Shani Shingnapur Temple Cab service provides dedicated transportation for temple darshan trips. Mumbai Airport Cab ensures safe travel, smooth highway driving, and comfortable vehicles for families and devotees visiting the temple."
},
{
name: "Mumbai to Shani Shingnapur Family Cab",
description: "Mumbai to Shani Shingnapur Family Cab service provides safe and comfortable transportation for families travelling together for pilgrimage. Mumbai Airport Cab offers spacious vehicles, experienced drivers, luggage-friendly travel, and flexible booking options for a stress-free journey."
},
{
name: "Mumbai to Shani Shingnapur Round Trip Cab",
description: "Mumbai to Shani Shingnapur Round Trip Cab service offers complete return journey solutions for same-day or multi-day temple visits. Mumbai Airport Cab ensures flexible scheduling, professional chauffeurs, and comfortable vehicles for a smooth round trip experience."
},
{
name: "Mumbai to Shani Shingnapur Innova Cab",
description: "Mumbai Airport Cab offers Mumbai to Shani Shingnapur Innova Cab service for families and groups needing spacious and comfortable travel. Our Innova vehicles provide ample seating, luggage space, and smooth ride quality for long pilgrimage journeys."
},
{
name: "Mumbai to Shani Shingnapur SUV Cab",
description: "Mumbai to Shani Shingnapur SUV Cab service provides powerful and comfortable vehicles suitable for highway and rural road travel. Mumbai Airport Cab ensures safe driving, spacious interiors, and smooth journey experience for groups and families."
},
{
name: "Mumbai to Shani Shingnapur Travel Package",
description: "Mumbai to Shani Shingnapur Travel Package offers customized pilgrimage travel plans including vehicle, itinerary, and flexible scheduling. Mumbai Airport Cab ensures comfortable transport and well-organized temple visits for a stress-free experience."
},
{
name: "Mumbai to Shani Shingnapur Religious Tour Cab",
description: "Mumbai to Shani Shingnapur Religious Tour Cab service provides organized spiritual travel for devotees. Mumbai Airport Cab ensures comfortable vehicles, experienced drivers, and safe highway travel for meaningful pilgrimage experiences."
},
{
name: "Mumbai to Shani Shingnapur Highway Cab",
description: "Mumbai to Shani Shingnapur Highway Cab service ensures safe and efficient long-distance travel across major routes. Mumbai Airport Cab provides professional chauffeurs, optimized routes, and comfortable vehicles for smooth temple journeys."
},
{
name: "Mumbai to Shani Shingnapur Budget Cab",
description: "Mumbai to Shani Shingnapur Budget Cab service offers economical travel options for pilgrimage without compromising safety or comfort. Mumbai Airport Cab ensures affordable pricing, clean vehicles, and reliable drivers for cost-effective journeys."
},
{
name: "Mumbai to Shani Shingnapur Express Cab",
description: "Mumbai to Shani Shingnapur Express Cab service provides fast and efficient transportation for urgent temple visits. Mumbai Airport Cab ensures quick pickup, optimized routes, and professional drivers for timely and smooth travel."
},
{
name: "Mumbai to Shani Shingnapur Night Travel Cab",
description: "Mumbai to Shani Shingnapur Night Travel Cab service provides safe overnight transportation for pilgrims. Mumbai Airport Cab ensures experienced drivers, secure travel conditions, and comfortable vehicles for peaceful night journeys."
}
],

tableData: [
["Mumbai to Shani Shingnapur Cab","Mumbai to Shani Shingnapur Taxi"],
["Mumbai to Shani Shingnapur Cab Fare","Mumbai to Shani Shingnapur Car Rental"],
["Mumbai to Shani Shingnapur One Way Cab","Mumbai to Shani Shingnapur Outstation Cab"],
["Mumbai to Shani Shingnapur Pilgrimage Cab","Mumbai to Shani Shingnapur Temple Cab"],
["Mumbai to Shani Shingnapur Family Cab","Mumbai to Shani Shingnapur Round Trip Cab"],
["Mumbai to Shani Shingnapur Innova Cab","Mumbai to Shani Shingnapur SUV Cab"],
["Mumbai to Shani Shingnapur Travel Package","Mumbai to Shani Shingnapur Religious Tour Cab"],
["Mumbai to Shani Shingnapur Highway Cab","Mumbai to Shani Shingnapur Budget Cab"],
["Mumbai to Shani Shingnapur Express Cab","Mumbai to Shani Shingnapur Night Travel Cab"]
],














whychoose: [
    {
        WhyChooseheading: "Reliable Mumbai to Shani Shingnapur Cab Service",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable Mumbai to Shani Shingnapur Cab services for devotees, families, senior citizens, religious groups, and pilgrims seeking comfortable travel."
    },
    {
        WhyChooseheading: "Convenient Shani Dev Darshan Journey",
        WhyChoosedescription: "Travel comfortably to the world-famous Shani Shingnapur Temple, one of India's most significant pilgrimage destinations dedicated to Lord Shani."
    },
    {
        WhyChooseheading: "Perfect for Religious and Spiritual Tours",
        WhyChoosedescription: "Our cab service is ideal for Shani Shingnapur Darshan, family pilgrimages, spiritual tours, temple visits, and customized religious travel plans."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles according to passenger count and travel requirements."
    },
    {
        WhyChooseheading: "One-Way and Round Trip Facilities",
        WhyChoosedescription: "Whether you require a one-way transfer, same-day return, round trip, or complete pilgrimage package, we offer flexible travel solutions."
    },
    {
        WhyChooseheading: "Pickup Available Across Mumbai",
        WhyChoosedescription: "Doorstep pickup services are available from Mumbai Airport, Navi Mumbai, Thane, Dombivli, Kalyan, Andheri, Borivali, Bandra, Dadar, Powai, and nearby locations."
    },
    {
        WhyChooseheading: "Experienced Drivers for Temple Routes",
        WhyChoosedescription: "Our professional chauffeurs are familiar with pilgrimage routes and ensure safe, comfortable, and hassle-free transportation throughout the journey."
    },
    {
        WhyChooseheading: "Ideal for Families, Senior Citizens, and Groups",
        WhyChoosedescription: "From individual devotees and families to large pilgrimage groups, we provide suitable vehicles for every religious travel requirement."
    }
]
};

const faqData = [
    {
        question: "Why do devotees book Mumbai to Shani Shingnapur Cabs?",
        answer: "Shani Shingnapur is one of the most revered temples dedicated to Lord Shani and attracts devotees from across India throughout the year."
    },
    {
        question: "Can I book a one-way cab from Mumbai to Shani Shingnapur?",
        answer: "Yes, one-way cab services are available along with round-trip and customized pilgrimage packages."
    },
    {
        question: "Which vehicle is suitable for Mumbai to Shani Shingnapur travel?",
        answer: "Sedan cars, Ertiga, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, and Mini Buses are available based on passenger count and comfort requirements."
    },
    {
        question: "Do you provide same-day return trips?",
        answer: "Yes, customers can choose same-day return journeys depending on their darshan schedule and travel requirements."
    },
    {
        question: "Can senior citizens travel comfortably on this route?",
        answer: "Yes, we provide spacious and comfortable vehicles suitable for elderly passengers, families, and long-distance travel."
    },
    {
        question: "Are Tempo Travellers available for religious groups?",
        answer: "Yes, Tempo Travellers and Mini Buses are available for pilgrimage groups, bhajan mandals, and large family gatherings."
    },
    {
        question: "Can I combine Shirdi and Shani Shingnapur in one trip?",
        answer: "Yes, customers frequently combine Shirdi Sai Baba Darshan and Shani Shingnapur Temple visits in a single customized itinerary."
    },
    {
        question: "Can pickup be arranged from Mumbai Airport?",
        answer: "Yes, pickup services are available from Mumbai Airport, hotels, railway stations, offices, and residential locations."
    },
    {
        question: "Is advance booking recommended for temple visits?",
        answer: "Yes, advance booking is recommended, especially during weekends, festivals, Shani Amavasya, and holiday seasons."
    },
    {
        question: "How can I book a Mumbai to Shani Shingnapur Cab?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Vinay Kulkarni",
        feedback:
            "Our Shani Shingnapur Darshan trip was very comfortable and well organized. The vehicle was clean, the driver was cooperative, and we completed the journey without any hassle.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Sunita Patil",
        feedback:
            "We booked a family pilgrimage package covering Shirdi and Shani Shingnapur. The service was excellent, the cab was spacious, and the entire trip was managed professionally.",
        rating: 5
    }
];

































   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];













const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Mumbai to Shani Shingnapur Cab",
"image": "https://www.mumbaiairportcabs.com/assets/images/mumbai-to-shani-shingnapur-cab.jpg",
"description": "Book Mumbai to Shani Shingnapur cab service for pilgrimage and temple travel. Mumbai Airport Cabs offers safe and comfortable outstation taxi service with professional drivers, one-way and round-trip options, and reliable 24x7 availability for spiritual journeys.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/mumbai-to-shani-shingnapur-cab"
}
};





    return (
        <div>




<Helmet>
  <title>Mumbai to Shani Shingnapur Cab | Temple Taxi Service | +91 9545731161</title>

<meta
 name="description"
 content="Book Mumbai to Shani Shingnapur cab for pilgrimage travel. Safe and comfortable temple taxi service with professional drivers, flexible one-way and round-trip options, and 24x7 availability."
/>

<meta
 name="keywords"
 content="mumbai to shani shingnapur cab, mumbai to shani shingnapur taxi, mumbai to shani shingnapur cab fare, mumbai to shani shingnapur car rental, mumbai to shani shingnapur one way cab, mumbai to shani shingnapur outstation cab, mumbai to shani shingnapur pilgrimage cab, mumbai to shani shingnapur temple cab"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>





            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/50.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitoshanishingnapurcab;